import { formatBytes32String } from '@ethersproject/strings';
import { Claim } from '@/classes/claimExtensionContract';

export function isEmptyMerkleRoot (merkleTree: string): boolean {
  return merkleTree === formatBytes32String('');
}

export function isExclusiveClaim (claim: Claim): boolean {
  return !isEmptyMerkleRoot(claim.merkleRoot);
}

export function isUnlimitedSupply (claim: Claim): boolean {
  return claim.totalMax === 0;
}

export function abbreviate (str: string, keepLeft = 4, keepRight = 4): string {
  if (!str) return str;
  return (
    str.substring(0, keepLeft) + '...' + str.substring(str.length - keepRight)
  );
}

export function abbreviateAddress (address: string): string {
  return abbreviate(address, 6, 4);
}

export function pluralize (count: number, singular: string, plural?: string): string {
  if (count === 1) {
    return singular;
  } else {
    return plural || singular + 's';
  }
}

export function sleep (ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function isJSON (str: any): boolean {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
